import { render } from "./ModalCreateDownload.vue?vue&type=template&id=22f82565"
import script from "./ModalCreateDownload.vue?vue&type=script&lang=js"
export * from "./ModalCreateDownload.vue?vue&type=script&lang=js"

import exportComponent from "/home/lino-guzman/code/descargas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__